import styled from 'styled-components';

export const StyledReport = styled.div` 
  .report-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;
    
    &-start {
      display: flex;
      align-items: center;
      flex-basis: 50%;
      > div:not(:last-child) {
        margin-inline-end: 15px;
      }
    }
    
    &-end {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex-basis: 50%;
    }

    .show-details {
      cursor: pointer;
    }

    .select {
      width: 190px;
    }

    .search {
      position: relative;
      font-size: 15px;
      line-height: 24px;
      color: ${props => props.theme.text};

      input {
        padding: 8px 20px;
        border: none;
        border-radius: 25px;
        box-shadow: 0 3px 10px rgba(89, 102, 137, .12);
      }

      img {
        position: absolute;
        left: ${({ ltr }) => ltr ? '' : '15px'};
        right: ${({ ltr }) => ltr ? '15px' : ''};
        top: 50%;
        transform: translateY(-50%);
        width: 20px;
      }
    }
    .report-pdf-icons {
      margin-inline-start: 15px !important;
    }
  }

  // table action buttons
  .actions-wrapper {
    margin: -10px -20px
  }

  .action-icon {
    margin: 7px;
    cursor: pointer;

    &.future {
      width: 24px;
      transform: rotate(45deg);
    }

    &.disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }

  #table {
    th {
      padding: 10px 20px;
    }
  }
`;

export const ReportTabs = styled.div`
  width: 340px;

  &.onetime-selected {
    .react-switch-selector-wrapper::before {
      left: 2px;
    }
  }

  .react-switch-selector-wrapper {
    direction: ltr;
    font-size: 14px;
    line-height: 22px;
    font-weight: bold;
    border-radius: 50px;

    &::before {
      height: calc(100% - 3px);
      width: calc(33% - 1px);
    }

    label {
      margin: 0;
    }
  }

  .react-switch-selector-option {
    padding: 9px 20px;
  }
`;

export const StyledActionsBar = styled.div`
  display: flex;
  align-items: center;
  padding: 35px 0;
  .actions-bar-search, .actions-bar-select {
    margin-inline-end: 15px;
  }
  .actions-button {
    margin: 0 15px;
  }
  .actions-bar-search {
    width: 230px;
  }
  .actions-bar-select {
    min-width: 120px;
    &.wide {
      width: 170px;
    }
  }
`;
